import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'
import { normalizeMessages } from '@/features/chat/messageNormalize'
import { appendPendingRunMessage, mergePendingRunProgress } from './backendRunProgressMessages'
import { serverMessageToClient, serverThreadToNav } from './backendChatSyncHelpers'

export function applyFetchedThreads(threads, state) {
  const navThreads = threads.map(serverThreadToNav)
  state.setThreads(navThreads)
  if (
    state.didSelectInitialServerThread.current ||
    state.displayThreadId ||
    state.selectedThreadId ||
    state.urlThreadId ||
    navThreads.length === 0
  ) {
    return
  }
  state.didSelectInitialServerThread.current = true
  state.setSelectedThreadId(navThreads[0].id)
}

export function applyFetchedThreadMessages(prev, threadId, detail, runs) {
  const serverMessages = Array.isArray(detail?.messages) ? detail.messages : []
  const messages = appendPendingRunMessage(serverMessages.map(serverMessageToClient), runs)
  if (messages.length === 0) return prev
  const existing = prev[threadId] || []
  const hasPending = existing.some(
    (message) => message.role === 'assistant' && message.text === ASSISTANT_PENDING_TEXT,
  )
  if (hasPending && runs.length > 0) {
    return { ...prev, [threadId]: normalizeMessages(mergePendingRunProgress(existing, runs)) }
  }
  if (hasPending && runs.length === 0 && !serverHasNewerAssistant(messages, existing)) return prev
  return { ...prev, [threadId]: normalizeMessages(messages) }
}

function serverHasNewerAssistant(serverMessages, existingMessages) {
  const existingWithoutPending = existingMessages.filter(
    (message) => !(message.role === 'assistant' && message.text === ASSISTANT_PENDING_TEXT),
  )
  if (serverMessages.length <= existingWithoutPending.length) return false
  return serverMessages.some((message) => message.role === 'assistant')
}
